export const FOC_KEYS = [
  'electricity',
  'water',
  'internet',
  'cleaning',
  'laundry',
  'service',
  'checkIn',
  'checkOut',
];

export const FOC_ROWS = [
  { key: 'electricity', label: 'Electricity' },
  { key: 'water', label: 'Water' },
  { key: 'internet', label: 'Internet' },
  { key: 'cleaning', label: 'Cleaning' },
  { key: 'laundry', label: 'Laundry' },
  { key: 'service', label: 'Service' },
  { key: 'checkIn', label: 'Check In' },
  { key: 'checkOut', label: 'Check Out' },
];

export const emptyFocRates = () => ({ perDay: 0, perCheckOut: 0, perMonth: 0 });

export const numberOrZero = value => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
};

export const ratesFromSource = row => {
  const src = row || {};
  return {
    perDay: numberOrZero(src.perDay),
    perCheckOut: numberOrZero(src.perCheckOut),
    perMonth: numberOrZero(src.perMonth),
  };
};

export const emptyFixedOperationCost = () => {
  const next = {};
  FOC_KEYS.forEach(key => {
    next[key] = emptyFocRates();
  });
  return next;
};

export const normalizeFixedOperationCost = foc => {
  const next = emptyFixedOperationCost();
  const src = foc || {};
  FOC_KEYS.forEach(key => {
    next[key] = ratesFromSource(src[key]);
  });
  return next;
};

export const isFocEmpty = foc => {
  const src = foc || {};
  return FOC_KEYS.every(key => {
    const rates = ratesFromSource(src[key]);
    return !rates.perDay && !rates.perCheckOut && !rates.perMonth;
  });
};

export const mergeListingOperationCost = listing => normalizeFixedOperationCost(listing);

export const resolveLoadedFoc = (savedFoc, listingOperationCost) => {
  if (!isFocEmpty(savedFoc)) return normalizeFixedOperationCost(savedFoc);
  if (!isFocEmpty(listingOperationCost)) return mergeListingOperationCost(listingOperationCost);
  return emptyFixedOperationCost();
};

export const setFocRate = (foc, key, field, value) => {
  const next = normalizeFixedOperationCost(foc);
  if (FOC_KEYS.indexOf(key) < 0) return next;
  next[key][field] = numberOrZero(value);
  return next;
};
